// extracted by mini-css-extract-plugin
export default {"mobileTable":"Table_mobileTable__2nGe2","desktopTable":"Table_desktopTable__hlvH3"};